import { z } from "zod";
import { HashedIdSchema } from "./schemas";
import { IUserGroupDetails } from "./IUserGroupDetails";

/**
 * Represents the user details.
 */
export const IUserDetailsSchema = z.object({
    userId: HashedIdSchema,
    userGuid: z.string().uuid(),
    fullName: z.string().optional(),
    email: z.string().email().optional(),
    countryCode: z.string().length(2).optional(),
    dateOfBirth: z.string().datetime().optional(),
    creationDate: z.string().datetime().optional(),
    status: z.string().optional(),
    gender: z.string().optional(),
    nickName: z.string().optional(),
    yearsTraining: z.number().int().optional(),
    expectedGraduationYear: z.number().int().max(2125).optional(),
    specialty: z.string().optional(),
    medicalSchool: z.string().optional(),
    organisation: z.string().optional(),
    totalActivities: z.number().int().optional(),
    totalDuration: z.number().int().optional(),
});

export type IUserDetails = z.infer<typeof IUserDetailsSchema>;

export const isIUserDetails = (obj: IUserDetails | IUserGroupDetails): obj is IUserDetails =>
    IUserDetailsSchema.safeParse(obj).success;

/**
 * Represents the  schema of user details Payload.
 * This is used to return a list of users
 * with the next page number to fetch the next set of users
 */
export const IUserPayloadSchema = z.object({
    users: z.array(IUserDetailsSchema),
    nextPage: z.number().int(),
});

/**
 * Represents the type of user details Payload.
 * This is used to return a list of users
 * with the next page number to fetch the next set of users
 */
export type IUserPayload = z.infer<typeof IUserPayloadSchema>;

export const IUserValueSchema = z.object({
    label: z.string(),
    value: z.string(),
});

export type IUserValue = z.infer<typeof IUserValueSchema>;

export const IUserDetailsPagedSchema = IUserDetailsSchema.extend({
    page: z.number().int(),
    isActive: z.boolean().optional(),
});

export type IUserDetailsPaged = z.infer<typeof IUserDetailsPagedSchema>;

export const IUserInitialSchema = z.object({
    fullName: z.string().optional().nullable(),
    email: z.string().email().optional().nullable(),
});

export type IUserInitial = z.infer<typeof IUserInitialSchema>;

export const IUserMinimalSchema = z.object({
    userId: HashedIdSchema,
    fullName: z.string(),
});

export type IUserMinimal = z.infer<typeof IUserMinimalSchema>;
